import { FormStepSectionWrapper } from '@common/features/DynamicPackagesConfigurationWizard/FormSteps/FormSteps.styles';
import { ItemDescription } from '@common/features/List/ListItem.styles';
import rewriteHttp from '@utils/rewriteHttp';
import { FC, Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { SpaEntityType } from 'shared-types/Spa';
import { sum } from 'shared-utils';
import { FormStep, PackagesFormValues } from '../../../types';
import { ExperienceDetails } from '../../ExperienceDetails';
import { ExperienceDetailsClasses } from '../../ExperienceDetails/ExperienceDetailsClasses';
import { ItemWrapper, OptionDivider, SpaImage, SpaImageWrapper } from '../ExperiencesGroup.styles';
import { usePackageConfiguration } from '../../../contexts';

interface Props {
  selectionGroup: Omit<FormStep, 'step' | 'type'>;
  allOptionsIncluded?: boolean;
  spaExperiences: Array<Partial<SpaEntityType> & { startTime?: string }>;
  plusMinusSpaOption: any;
  totalGuests: number;
  dayNumber: number;
}

export const ExperiencesGroupOptions: FC<Props> = ({
  selectionGroup,
  allOptionsIncluded,
  spaExperiences,
  plusMinusSpaOption,
  totalGuests,
  dayNumber,
}) => {
  // Get property from context
  const { property } = usePackageConfiguration();

  const { watch } = useFormContext<PackagesFormValues>();
  const selectedExperiences = watch('selectedExperiences');
  const selectionsInOptionGroup = (selectedExperiences || []).filter(
    (exp) => exp.optionGroupId === selectionGroup.optionGroupId && exp.dayNumber === dayNumber
  );

  const totalNumberOfSelectionsInGroup = sum(selectionsInOptionGroup, (option) => option.count);

  const maxSelectionsForGroup = totalGuests * (selectionGroup.selectionsRequired || 1);

  return (
    <>
      <FormStepSectionWrapper>
        {spaExperiences?.map((exp, index) => {
          const optionId = selectionGroup.options?.find(
            (g) => Number(g.id) === Number(exp.id)
          )?.optionId;
          const spaOptionCount =
            selectedExperiences?.find(
              (option) =>
                option.id === exp?.id &&
                option.optionId === optionId &&
                option.dayNumber === dayNumber
            )?.count || 0;

          const experienceDetailProps = {
            entityType: selectionGroup.experienceType,
            id: Number(exp?.id),
            language: property.defaultLanguage,
            propertyId: property.id,
            count: spaOptionCount || 0,
            plusMinusSpaOption: plusMinusSpaOption,
            disabledMinus: spaOptionCount === 0,
            disabledPlus:
              spaOptionCount >= totalGuests ||
              totalNumberOfSelectionsInGroup >= maxSelectionsForGroup,
            allOptionsIncluded,
            unavailable: exp?.unAvailable,
            optionId: Number(optionId),
            spaEntity: exp,
          };
          return (
            <Fragment key={exp.id ?? index}>
              <ItemWrapper
                noImage={selectionGroup.experienceType === 'spa-classes'}
                data-unavailable={exp?.unAvailable}
              >
                <>
                  {exp.type === 'spa-classes' ? (
                    <div />
                  ) : (
                    <SpaImageWrapper isFullDim>
                      <SpaImage url={rewriteHttp(exp?.image?.url || exp?.imageGallery?.[0].url)} />
                    </SpaImageWrapper>
                  )}
                  <ItemDescription>
                    {exp.type === 'spa-classes' ? (
                      <ExperienceDetailsClasses {...experienceDetailProps} />
                    ) : (
                      <ExperienceDetails {...experienceDetailProps} />
                    )}
                  </ItemDescription>
                </>
              </ItemWrapper>
              {index < spaExperiences.length - 1 && <OptionDivider />}
            </Fragment>
          );
        })}
      </FormStepSectionWrapper>
    </>
  );
};
